import type { FilterStand, Lijst } from '@xxtract/tabelfilters';
import { leesStapFilter, STAPFILTERS, type StapFilter } from './stapFilter';

/**
 * spec-tabelfilters story 6 — periode en stap van behandeltijd als paginafilter (CAP-13, CAP-14).
 *
 * Ze sturen kaarten, grafiek én tabel, dus het zijn geen kolomfilters. Ze leven in de lijststand en
 * niet meer in het adres; een oude link met `from`, `to` en `stap` blijft werken als binnenkomende
 * link. `alleenKolomfilters`: `sort` en `page` in zo'n link horen bij de tabel ernaast.
 */
export const BEHANDELTIJD_PAGINAFILTER: Lijst<unknown> = {
  alleenKolomfilters: true,
  kolommen: [
    { sleutel: 'periode', kopSleutel: 'handlingTime.periode', type: 'datum', urlVan: 'from', urlTot: 'to', waarde: () => null },
    { sleutel: 'stap', kopSleutel: 'handlingTime.stapfilter.label', type: 'keuzelijst', enkelvoudig: true, vasteWaarden: STAPFILTERS, waarde: () => null },
  ],
};

export interface Paginafilter {
  from?: string;
  to?: string;
  stap: StapFilter;
}

/**
 * Lijststand → periode en stap. Alleen een ONTBREKENDE periode is "standaard": een half of helemaal
 * leeggemaakt bereik blijft leeg, anders is het scherm niet met de hand in te vullen.
 */
export function leesPaginafilter(filters: FilterStand | undefined, standaard: { from: string; to: string }): Paginafilter {
  const periode = filters?.periode;
  const stap = filters?.stap;
  const bereik = periode && typeof periode === 'object' && !Array.isArray(periode) ? { from: periode.van, to: periode.tot } : standaard;
  return { ...bereik, stap: leesStapFilter(Array.isArray(stap) ? stap[0] : undefined) };
}
